var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c("div", { staticClass: "main-content" }, [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { height: "100%", "min-height": "870px" }
        },
        [
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: {
                width: "15%",
                "min-width": "190px",
                border: "1px solid #ccc",
                display: "flex",
                cursor: "pointer"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "min-height": "500px"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.trackingTree.gridOptions,
                  "column-defs": _vm.trackingTree.columnDefs,
                  "row-data": _vm.trackingTree.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "min-width": "85%",
                border: "1px solid #ccc",
                display: "flex",
                height: "100%"
              }
            },
            [
              _vm.optModule.tracking
                ? _c("tracking", {
                    ref: "trackingModule",
                    attrs: {
                      "tree-node": _vm.currentState.treeNode,
                      "tracking-tree": _vm.trackingTree
                    },
                    on: {
                      addTrackingDetail: _vm.toAddDetail4Tracking,
                      refreshTree: _vm.toRefreshTree
                    }
                  })
                : _vm._e(),
              _vm.optModule.trackingDetail
                ? _c("tracking-detail", {
                    ref: "trackingDetailModule",
                    attrs: {
                      "tree-node": _vm.currentState.treeNode,
                      "tracking-list": _vm.trackingTree.rowData
                    },
                    on: { refreshTree: _vm.toRefreshTree }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }